import type { Nullable } from '@clearverify/types';

import { useEmployeeInviteIdQuery } from 'src/api';

/**
 * Fetches only the pending invite id for an employee's user. Kept separate from
 * the shared `useUser` query so the employee actions menu doesn't eagerly load
 * the full user record (avatar, profile) for every search-result card.
 */
export const useEmployeeInvite = (userId: Nullable<string>, options: { skip?: boolean } = {}) => {
  const { data, loading } = useEmployeeInviteIdQuery({
    variables: {
      userId: userId || '',
    },
    skip: options.skip || !userId,
  });

  return { inviteId: data?.getEmployeeInviteId, loading };
};
